import validateAllRegistrationForms
  from '../actions/validateAllRegistrationForms'
import stepSetValidating from '../actions/stepSetValidating'
import stepSetUnvalidating from '../actions/stepSetUnvalidating'
import { copy } from 'cerebral/operators'
import redirectRegistration from '../actions/redirectRegistration'
import sendAllRegistration from '../actions/sendAllRegistration'
import shouldRedirectToModule from '../actions/shouldRedirectToModule'
import redirectToModule from '../actions/redirectToModule'
import resetAllForms from '../../user/factories/resetAllForms'
import validateRegistrationFields from '../actions/validateRegistrationFields'

export default [
  stepSetValidating,
  validateRegistrationFields,
  {
    false: [],
    true: [
      validateAllRegistrationForms,
      {
        success: [
          sendAllRegistration,
          {
            error: [],
            success: [
              shouldRedirectToModule,
              {
                true: [redirectToModule],
                false: [
                  resetAllForms,
                  copy('input:nextPage', 'output:currentPage'),
                  redirectRegistration
                ]
              }
            ]
          }
        ],
        error: [
          copy('input:firstInvalidForm', 'output:currentPage'),
          redirectRegistration
        ]
      }
    ]
  },

  stepSetUnvalidating
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/finishRegistration.js